import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'sbDefaultRoleTranslate',
  pure: true,
  standalone: false,
})
export class DefaultRoleTranslator implements PipeTransform {
  friendlyNames: Record<string, string> = {
    'role.ca.authorization_management': marker('role.ca.authorization_management'),
    'role.ca.client_administration': marker('role.ca.client_administration'),
    'role.ca.master_data_management': marker('role.ca.master_data_management'),
    'role.ds.campaign_administration': marker('role.ds.campaign_administration'),
    'role.ds.campaign_management': marker('role.ds.campaign_management'),
    'role.ds.customer_maintenance': marker('role.ds.customer_maintenance'),
    'role.ds.customer_management': marker('role.ds.customer_management'),
    'role.ds.planning': marker('role.ds.planning'),
    'role.ds.planning_audit': marker('role.ds.planning_audit'),
    'role.mm.content_administration': marker('role.mm.content_administration'),
    'role.mm.content_audit': marker('role.mm.content_audit'),
    'role.mm.content_delivery': marker('role.mm.content_delivery'),
    'role.mm.content_management': marker('role.mm.content_management'),
    'role.ss.device_administration': marker('role.ss.device_administration'),
    'role.ss.device_maintenance': marker('role.ss.device_maintenance'),
    'role.ss.device_management': marker('role.ss.device_management'),
    'role.ss.location_administration': marker('role.ss.location_administration'),
    'role.ss.location_maintenance': marker('role.ss.location_maintenance'),
    'role.ss.location_management': marker('role.ss.location_management'),
    'role.ss.location_operator': marker('role.ss.location_operator'),
    'role.ss.merchandising': marker('role.ss.merchandising'),
    'role.ss.publisher_administration': marker('role.ss.publisher_administration'),
    'role.ss.technical_field_service': marker('role.ss.technical_field_service'),
  };

  constructor(public translate: TranslateService) {}
  transform(defaultRole: any) {
    if (defaultRole) {
      let translation = defaultRole;
      try {
        translation = this.translate.instant(this.friendlyNames[defaultRole]);
      } catch (e) {}
      return translation;
    } else {
      return null;
    }
  }
}
